export default () => ({
    textField: {
        flex: '1 1 100%',
    },
});
